import {
    PillarPaymentResponseType,
    type PaymentTransactionAmountBreakdown,
    type TransactionLifecycleEvent,
} from './payment.types';
import { GatewayId } from '@pillar-portal/database/dist/frontend';

export interface SurchargePresentationLabels {
    surcharge: string;
    surchargeAmount: string;
    surchargeRefunded: string;
}

export function getSurchargePresentationLabels(gatewayId: GatewayId): SurchargePresentationLabels {
    switch (gatewayId) {
        case GatewayId.VALOR_US:
        case GatewayId.CARDPOINTE:
            return {
                surcharge: 'Surcharge',
                surchargeAmount: 'Surcharge Amount',
                surchargeRefunded: 'Surcharge Refunded',
            };
        case GatewayId.CLOVER:
            return {
                surcharge: 'Credit surcharge (Clover)',
                surchargeAmount: 'Credit surcharge (Clover)',
                surchargeRefunded: 'Credit surcharge refunded (Clover)',
            };
    }

    const exhaustiveGatewayId: never = gatewayId;
    throw new Error(`Unsupported gateway id ${String(exhaustiveGatewayId)}`);
}

export function getCumulativeRefundAmountBreakdown(
    transactionLifecycleEvents: readonly TransactionLifecycleEvent[]
): PaymentTransactionAmountBreakdown | null {
    const transactionLifecycleEventsNewestFirst = [...transactionLifecycleEvents].sort(
        (left, right) =>
            right.payment_transaction_lifecycle_event_id -
            left.payment_transaction_lifecycle_event_id
    );

    for (const transactionLifecycleEvent of transactionLifecycleEventsNewestFirst) {
        const pillarPaymentResponse = transactionLifecycleEvent.pillar_response;
        if (
            pillarPaymentResponse?.response_type === PillarPaymentResponseType.REFUND_TRANSACTION &&
            pillarPaymentResponse.response.success &&
            pillarPaymentResponse.response.cumulative_refund_amount_breakdown !== undefined
        ) {
            return pillarPaymentResponse.response.cumulative_refund_amount_breakdown;
        }
    }

    return null;
}
